import { render, staticRenderFns } from "./Praesenzjournalliste.vue?vue&type=template&id=2272330d"
import script from "./Praesenzjournalliste.vue?vue&type=script&lang=js"
export * from "./Praesenzjournalliste.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports